function getDefaultPerspective(compWidth: number) {
  return compWidth * 1.38888;
}

export default getDefaultPerspective;
